import { Handle, type NodeProps } from "@xyflow/react";
import type { ExistenceNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export function ExistenceNode({ data }: NodeProps) {
  const d = data as ExistenceNodeData;
  const { inputPosition, outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div className="rounded-md border border-cyan-300 bg-cyan-50 px-3 py-2 text-xs shadow-sm min-w-[80px]">
      <Handle type="target" position={inputPosition} id="operand" />
      <div className="font-medium text-cyan-700 text-[10px] mb-0.5">
        CHECK
      </div>
      <div className="text-cyan-900 font-mono text-center text-sm font-bold">
        {d.label || d.operator}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
